(function (angular) {
  'use strict';

  angular
    .module('bossApp.olvido', [])
    .component('olvido', {
      templateUrl: 'src/app/components/olvido/olvido.template.html',
      controller: OlvidoCtrl,
      controllerAs: 'olvidoCtrl',
      transclude: true,
      bindings: {

      }
    });

  OlvidoCtrl.$inject = ['$log', 'URLS', 'user', '$element'];

  function OlvidoCtrl($log, URLS, user, $element) {
    var vm = this;
    vm.submit = function () {
      $element.find('form').submit()
    }
    vm.data = {};
    vm.data.origen = user.origen;
    vm.data.idioma = user.idioma;
    vm.data.url = URLS.urlOlvido.url;

    if (angular.isDefined(URLS.urlOlvido.mock)  && URLS.urlOlvido.mock === true) {
    	vm.data.url = URLS.urlOlvido.urlMock;
    }

  }


})(angular);
